import { Field } from "react-final-form"

import { ALink, CheckboxControl } from "@trueskin-web/components"
import { required } from "@trueskin-web/functions"
import { Slugs, Trans, useTranslation } from "@trueskin-web/translations"

const TermsAgreement = () => {
  const { t } = useTranslation()

  return (
    <Field
      data-testid="web-portal-shipping-form-agree-terms"
      name="agreeTerms"
      type="checkbox"
      component={CheckboxControl}
      validate={(value) =>
        required(value, t("Start.CreateAccount.mandatoryFieldError"))
      }
      sx={{
        my: 2,
        "& input ~ div": {
          borderRadius: 4,
          borderColor: "textLight",
          boxShadow: "none",
        },
      }}
    >
      <span sx={{ fontSize: 1 }}>
        <Trans
          i18nKey="Start.CreateAccount.agreeTerms"
          components={{
            terms: (
              <ALink
                href={Slugs["terms-and-conditions"].url}
                target="_blank"
                isUnderlined
              />
            ),
            policy: (
              <ALink
                href={Slugs["data-protection"].url}
                target="_blank"
                isUnderlined
              />
            ),
          }}
        />
      </span>
    </Field>
  )
}

export default TermsAgreement
